import { render, staticRenderFns } from "./NavigationCategoriesItem.vue?vue&type=template&id=dc79bd26&scoped=true&"
import script from "./NavigationCategoriesItem.vue?vue&type=script&lang=js&"
export * from "./NavigationCategoriesItem.vue?vue&type=script&lang=js&"
import style0 from "./NavigationCategoriesItem.vue?vue&type=style&index=0&id=dc79bd26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc79bd26",
  null
  
)

export default component.exports